module.exports = __webpack_public_path__ + "static/media/Low-Power-Displays-Main-Image--F.9b789bc7.jpg";